import e from "./ExamplePicker.vue_vue_type_script_setup_true_lang.js";
//#region src/code-example/components/ExamplePicker.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=ExamplePicker.vue.js.map